









































import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPagination } from "bootstrap-vue";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import Pager from "@/components/schedule/Pager.vue";
import CalendarView from "@/components/schedule/Calendar.vue";
import ListView from "@/components/schedule/List.vue";
import ApptEditor from "@/components/schedule/Appt.vue";
import ApptLog from "@/components/schedule/Log.vue";
import { ScheduleView } from "@/store/modules/enums";
import StatusCount from "@/components/schedule/StatusCount.vue";
import ReminderCount from "@/components/schedule/ReminderCount.vue";

@Component({
  components: {
    BPagination,
    Header,
    EntityTabs,
    Pager,
    CalendarView,
    ListView,
    ApptEditor,
    ApptLog,
    StatusCount,
    ReminderCount
  },
  computed: {
    ...mapState("schedule", ["view", "list","reminderCount", "statusCount"]),
  },
})
export default class Schedule extends Vue {
  view!: ScheduleView;
  list!: any;
  reminderCount!: any;
  statusCount!: any;
  selected: any | null = null;
  @Watch("list.filter", { deep: true })
  onFilterChanged() {
    this.getAppts();
    /* this.getApptStatusCount(); */
  }
  async getAppts() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/getApptList");
      this.getApptStatusCount();
      this.getApptReminderCount();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getApptStatusCount() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/getApptStatusCount");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getApptReminderCount() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/getApptReminderCount");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  editAppt(appt: any) {
    this.selected = appt;
    this.$modal.show("appt-editor");
  }
  showLog(appt: any) {
    this.selected = appt;
    this.$modal.show("appt-log");
  }
  get ScheduleView() {
    return ScheduleView;
  }
  mounted() {
    this.getAppts();
    this.getApptStatusCount();
  }
}
